<template>
  <div class="col-12 col-lg-6  weather-item-col">
    <div class="weather-item">
      <div class="weather-item__title">
        <span>Инсоляция</span><img src="@/assets/images/icon_sun_01.svg" width="24" alt=""></div>
      <div class="weather-insolation-block">
        <div class="weather-insolation-block__text left">Азимут</div>
        <div class="weather-insolation-block__text right">Высота</div>
        <div class="weather-insolation-block__items">
          <div class="weather-insolation-circle-first-wrapp">
            <div class="weather-insolation-circle-first">
              <svg width="100%" height="100%" class="weather-insolation-circle-first__svg">
                <circle class="wind-circle-segment" cx="106" cy="106" r="104" stroke-width="4" fill="transparent" stroke="#696a6b" stroke-dasharray="100 0" stroke-dashoffset="0"></circle>
              </svg>
            </div>
            <div class="weather-pressure__count">
              <div class="weather-pressure__count_line"></div>
            </div>
            <div class="weather-insolation-sun-line-wrapp" :style="{transform : 'rotate('+sun.azimuth+'deg)'}">
              <div class="weather-insolation-sun-line">
                <div>
                  <svg viewBox="0 0 176 176" style="width: 24px; height: 24px;">
                    <g>
                      <path fill="#ff740e" d="M88,130.067c23.748,0,43-19.252,43-43c0-23.748-19.252-43-43-43   s-43,19.252-43,43C45.026,110.805,64.263,130.042,88,130.067"/>
                      <path fill="#ff740e" d="M88,32c4.418,0,8-3.582,8-8V8c0-4.418-3.582-8-8-8s-8,3.582-8,8v16   C80,28.418,83.582,32,88,32"/>
                      <path fill="#ff740e" d="M80,152v16c0,4.418,3.582,8,8,8s8-3.582,8-8v-16c0-4.418-3.582-8-8-8   S80,147.582,80,152"/>
                      <path fill="#ff740e" d="M144,88c0,4.418,3.582,8,8,8h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16   C147.582,80,144,83.582,144,88"/>
                      <path fill="#ff740e" d="M8,96h16c4.418,0,8-3.582,8-8s-3.582-8-8-8H8c-4.418,0-8,3.582-8,8   S3.582,96,8,96"/>
                      <path fill="#ff740e" d="M133.255,50.745c2.122,0.003,4.158-0.84,5.657-2.343l11.313-11.314   c3.124-3.125,3.124-8.19-0.001-11.314s-8.189-3.124-11.313,0.001L127.6,37.088c-3.124,3.124-3.124,8.189,0,11.314   c1.5,1.5,3.535,2.343,5.657,2.343H133.255z"/>
                      <path fill="#ff740e" d="M37.088,127.6l-11.314,11.313c-3.125,3.125-3.125,8.189,0,11.314   s8.19,3.125,11.315,0L48.4,138.912c3.178-3.069,3.266-8.134,0.197-11.313c-3.07-3.178-8.134-3.266-11.312-0.196   C37.218,127.468,37.152,127.533,37.088,127.6z"/>
                      <path fill="#ff740e" d="M138.912,127.6c-3.069-3.178-8.134-3.266-11.313-0.195   c-3.178,3.068-3.266,8.134-0.195,11.312c0.063,0.066,0.129,0.132,0.195,0.196l11.313,11.313c3.125,3.125,8.189,3.125,11.314,0   s3.125-8.189,0-11.314L138.912,127.6z"/>
                      <path fill="#ff740e" d="M37.088,48.4c3.069,3.178,8.134,3.266,11.312,0.197   c3.178-3.07,3.266-8.134,0.197-11.312c-0.065-0.067-0.13-0.133-0.197-0.197L37.089,25.775c-3.124-3.125-8.189-3.125-11.314-0.001   s-3.125,8.189-0.001,11.314L37.088,48.4z"/>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="weather-insolation-circle-second-wrapp">
            <div class="weather-insolation-circle-second">
              <div class="weather-insolation-circle-second__sun" :style="{transform : 'rotate('+sun.height+'deg)'}">
                <svg viewBox="0 0 176 176" style="width: 24px; height: 24px;">
                  <g>
                    <path fill="#ff740e" d="M88,130.067c23.748,0,43-19.252,43-43c0-23.748-19.252-43-43-43   s-43,19.252-43,43C45.026,110.805,64.263,130.042,88,130.067"/>
                    <path fill="#ff740e" d="M88,32c4.418,0,8-3.582,8-8V8c0-4.418-3.582-8-8-8s-8,3.582-8,8v16   C80,28.418,83.582,32,88,32"/>
                    <path fill="#ff740e" d="M80,152v16c0,4.418,3.582,8,8,8s8-3.582,8-8v-16c0-4.418-3.582-8-8-8   S80,147.582,80,152"/>
                    <path fill="#ff740e" d="M144,88c0,4.418,3.582,8,8,8h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16   C147.582,80,144,83.582,144,88"/>
                    <path fill="#ff740e" d="M8,96h16c4.418,0,8-3.582,8-8s-3.582-8-8-8H8c-4.418,0-8,3.582-8,8   S3.582,96,8,96"/>
                    <path fill="#ff740e" d="M133.255,50.745c2.122,0.003,4.158-0.84,5.657-2.343l11.313-11.314   c3.124-3.125,3.124-8.19-0.001-11.314s-8.189-3.124-11.313,0.001L127.6,37.088c-3.124,3.124-3.124,8.189,0,11.314   c1.5,1.5,3.535,2.343,5.657,2.343H133.255z"/>
                    <path fill="#ff740e" d="M37.088,127.6l-11.314,11.313c-3.125,3.125-3.125,8.189,0,11.314   s8.19,3.125,11.315,0L48.4,138.912c3.178-3.069,3.266-8.134,0.197-11.313c-3.07-3.178-8.134-3.266-11.312-0.196   C37.218,127.468,37.152,127.533,37.088,127.6z"/>
                    <path fill="#ff740e" d="M138.912,127.6c-3.069-3.178-8.134-3.266-11.313-0.195   c-3.178,3.068-3.266,8.134-0.195,11.312c0.063,0.066,0.129,0.132,0.195,0.196l11.313,11.313c3.125,3.125,8.189,3.125,11.314,0   s3.125-8.189,0-11.314L138.912,127.6z"/>
                    <path fill="#ff740e" d="M37.088,48.4c3.069,3.178,8.134,3.266,11.312,0.197   c3.178-3.07,3.266-8.134,0.197-11.312c-0.065-0.067-0.13-0.133-0.197-0.197L37.089,25.775c-3.124-3.125-8.189-3.125-11.314-0.001   s-3.125,8.189-0.001,11.314L37.088,48.4z"/>
                  </g>
                </svg>
              </div>
              <div class="weather-insolation-circle-second__deg">
                <svg width="100%" height="100%" viewBox="0 0 106 106" class="weather-insolation-circle-second__svg">
                  <circle cx="53" cy="53" r="15.91549430918954" stroke-width="0.1" fill="transparent" stroke="#696a6b" :stroke-dasharray="sunHeight" stroke-dashoffset="50"></circle>
                </svg>
                <div :class="sunDegFix" class="count">{{ sun.height }} °</div>
              </div>
            </div>
            <div class="weather-pressure__count">
              <div class="weather-pressure__count_line"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="weather-insolation-table-wrapp">
        <div class="weather-insolation-table-new-wr">
          <div class="weather-insolation-table">
            <div><p>В плоскости</p><span>{{ plane }}</span></div>
            <div><p>В горизонтали</p><span>{{ horizontal }}</span></div>
          </div>
        </div>
        <div class="weather-insolation-table-new-wr">
          <div class="weather-insolation-table">
            <div class="sun-up"><p>Время восхода</p><span>{{ sun.sunrise }}</span></div>
            <div class="sun-down"><p>Время заката</p><span>{{ sun.sunset }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SunCalc from 'suncalc'
import moment from 'moment'
import Meteo from '@/helpers/Meteo'
import object from 'lodash/object'

export default {
  name: 'Insolation',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  created () {
    this.meteo = new Meteo(this.station)
    this.weatherSolarHeigt()
  },
  data () {
    return {
      meteo: null,
      lat: 50.448,
      lon: 30.52,
      sun: {
        sunrise: '',
        sunset: '',
        azimuth: -20 + 90,
        height: 45,
        up: '7:40',
        down: '22:40'
      }
    }
  },
  methods: {
    weatherSolarHeigt () {
      let time = SunCalc.getTimes(moment()
        .valueOf(), this.lat, this.lon)
      let position = SunCalc.getPosition(moment()
        .valueOf(), this.lat, this.lon)
      let positionSunrise = SunCalc.getPosition(time.sunrise, this.lat, this.lon).azimuth * 180 / Math.PI
      let positionSunset = SunCalc.getPosition(time.sunset, this.lat, this.lon).azimuth * 180 / Math.PI
      let k = 180 / (positionSunset - positionSunrise)

      this.sun.sunrise = moment(time.sunrise)
        .format('HH:mm:ss')
      this.sun.sunset = moment(time.sunset)
        .format('HH:mm:ss')

      if (position.altitude * 180 / Math.PI > 0) {
        this.sun.height = Math.round(position.altitude * 180 / Math.PI)
        this.sun.azimuth = Math.round(position.azimuth * 180 / Math.PI) * k + 90
      } else {
        this.sun.height = 0
        this.sun.azimuth = 0
      }
    }
  },
  computed: {
    plane () {
      if (this.$store.getters['station/lastData'] === null) {
        return 0
      }
      const path = [this.meteo.getPlaneId(), this.meteo.getInsolation()]

      return object.get(this.$store.getters['station/lastData'], path)
    },
    horizontal () {
      if (this.$store.getters['station/lastData'] === null) {
        return 0
      }
      const path = [this.meteo.getHorizontalId(), this.meteo.getInsolation()]

      return object.get(this.$store.getters['station/lastData'], path)
    },
    sunDegFix () {
      if (this.sun.height > 18 && this.sun.height < 25) {
        return 'bottom-1'
      } else if (this.sun.height > 12 && this.sun.height <= 18) {
        return 'bottom-2'
      } else {
        return ''
      }
    },
    sunHeight () {
      const maxDeg = 90
      const maxLineCircle = 25
      const coefficient = maxLineCircle / maxDeg
      let dasharrayStart = this.sun.height * coefficient

      if (dasharrayStart < 0) {
        dasharrayStart = 0
      } else if (dasharrayStart > maxLineCircle) {
        dasharrayStart = maxLineCircle
      }
      let dasharrayStop = 100 - dasharrayStart
      return dasharrayStart + ' ' + dasharrayStop
    }
  }
}
</script>
